import React from 'react';
import PropTypes from 'prop-types';
import styles from './helpCenterListWrapper.module.scss';
import HelpCenterListItem from '../helpCenterListItem/helpCenterListItem';

function helpCenterListWrapper({
  moduleSplit = '',
  moduleType = '',
  modules = {
    title: '',
    modulePosition: '',
    items: [],
  },
}) {
  let containerStyle = 'fullContainer';
  if (moduleSplit === '50%-50%') {
    containerStyle = 'halfContainer';
  }
  return (
    <div className={styles.helpCenterListWrapper}>
      <div
        className={`${
          !!modules.modulePosition && styles[`${modules.modulePosition}`]
        }
                ${!!containerStyle && styles[`${containerStyle}`]}
                ${
                  moduleType === 'box'
                    ? styles.itemMainBox
                    : styles.itemMainList
                }`}
      >
        {modules.title && (
          <div className={styles.header}>
            <h2 className={styles.title}>{modules.title}</h2>
          </div>
        )}
        {modules.items && (
          <div className={`${styles.listItems}`}>
            <div className={`${styles.outerList}`}>
              {modules.items?.map((item, index1) => {
                const key1 = `help-center-list-${index1}`;
                return (
                  <div
                    className={
                      moduleType === 'box' ? styles.itemBox : styles.itemList
                    }
                    key={key1}
                  >
                    <div className={styles.innerList}>
                      <HelpCenterListItem {...item} moduleType={moduleType} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

helpCenterListWrapper.propTypes = {
  moduleSplit: PropTypes.string,
  moduleType: PropTypes.string,
  modules: PropTypes.shape({
    title: PropTypes.string,
    modulePosition: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string,
        description: PropTypes.string,
        link: PropTypes.string,
        subProducts: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
          })
        ),
        subProductsPosition: PropTypes.string,
        subProductsAlignment: PropTypes.string,
        icon: PropTypes.shape({
          path: PropTypes.string,
          alt: PropTypes.string,
        }),
        iconPosition: PropTypes.string,
      })
    ),
  }),
};

export default helpCenterListWrapper;
